<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "Forget Password" | translate }}</h3>
    <p class="mt-5">
      {{
        "Enter your email to send OTP code to reset your password" | translate
      }}
    </p>
    <label>{{ "Email" | translate }}</label>
    <div class="input-container mt-1">
      <i class="bi bi-envelope left-icon"></i>
      <input type="text" placeholder="{{ 'Enter your email' | translate }}" />
    </div>

    <button class="w-100 mt-5 btn" [routerLink]="'/' + lang + '/otpcode'">
      {{ "Send OTP Code" | translate }}
    </button>

    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" [routerLink]="'/' + lang + '/login'">{{
        "Login" | translate
      }}</span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 pt-5 right-container">
    <img width="50%" [src]="logo" />
  </div>
</div>
